import React, { PropTypes } from 'react'
import classnames from 'classnames'
import styles from './CardFooter.scss'

const CardFooter = ({
  children, className, right, left,
}) => {
  const ifNotRight = left ? styles.left : {}

  return (<div className={`${classnames(styles.cardFooter, right ? styles.right : ifNotRight)} ${className}`}>
    {children}
  </div>)
}

CardFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  right: PropTypes.bool,
  left: PropTypes.bool,
}

CardFooter.defaultProps = {
  children: null,
  className: null,
  right: false,
  left: false,
}

export default CardFooter



// WEBPACK FOOTER //
// ./src/components/CardFooter/CardFooter.js